import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/disk/external_visit.svg';
const ExternalVisit = () => React.createElement(IconSvg, null);
export default ExternalVisit;
